import { render, staticRenderFns } from "./staticsCard.vue?vue&type=template&id=334f30cf&scoped=true"
import script from "./staticsCard.vue?vue&type=script&lang=js"
export * from "./staticsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334f30cf",
  null
  
)

export default component.exports